<template>
  <main-layout :selectedMenu="'home'">
    <div class="lookBox" v-if="type == 3">
      <div class="lookFolder clearfix">
        <div class="leftBox">
          <div class="leftTopBox" v-if="isShow">
            <p class="lookTitle">
              <img
                class="icon1"
                src="/static/collect/icon_playlist@2x.png"
                alt=""
              />{{ $t("collect.看单") }}
            </p>
            <p class="title">{{ details.name }}</p>
            <div class="lookInfo">
              <span
                class="name"
                @click.stop.prevent="goto('people', details.userId)"
                >{{ $t("collect.创建者") }}：<img
                  class="icon2"
                  :src="details.userAvatar | imageUrl('', 52, 52)"
                  alt=""
                />{{ details.nickName }}</span
              ><span class="time"
                >
                {{ $t("collect.更新",{time: formatDate(details.updateTime)}) }}</span
              ><span class="count"
                ><img
                  class="icon3"
                  src="/static/video/view_icon@2x.png"
                  alt=""
                />{{ getNumber(details.viewCount) }}</span
              ><span class="reportBox" @click="reportVisible = true"
                ><img
                  class="icon4"
                  src="/static/collect/icon_playlist_report@2x.png"
                  alt=""
                />{{ $t("global.举报") }}</span
              >
            </div>
            <div class="bottomBox clearfix">
              <div
                class="playAll"
                :class="{ playAllNo: details.videoCount == 0 }"
                @click="gotoVideo(details.id)"
              >
                <img
                  class="icon5"
                  src="/static/collect/icon_playlist_hover_playall@2x.png"
                  alt=""
                />{{ $t("collect.播放全部") }}
              </div>
              <div
                class="collectClose"
                @click="collectLook(2)"
                v-if="details.isCollect"
                @mouseenter="ishover = true"
                @mouseleave="ishover = false"
              >
                {{ ishover ? $t("collect.取消收藏") : $t("collect.已收藏")
                }}<i v-if="!ishover">{{ details.collectCount || 0 }}</i>
              </div>
              <div
                class="collectAdd"
                :class="{ notClick: userId == details.userId }"
                @click="collectLook(1)"
                v-else
              >
                <img
                  class="icon6"
                  :src="
                    userId == details.userId
                      ? '/static/collect/icon_playlist_save_btn_disabled@2x.png'
                      : '/static/collect/icon_playlist_save_btn@2x.png'
                  "
                  alt=""
                />{{ $t("global.收藏") }}<i>{{ details.collectCount || 0 }}</i>
              </div>
              <el-popover placement="bottom" width="240px" trigger="hover">
                <share :config="config"></share>
                <div class="config" slot="reference">
                  <img
                    class="icon7"
                    src="/static/collect/icon_playlist_share_btn@2x.png"
                    alt=""
                  />{{ $t("global.分享") }}
                </div>
              </el-popover>
            </div>
          </div>
          <div class="leftVideoListBox" v-if="details.videoCount > 0">
            <p class="title">
              {{ $t("collect.共") }}{{ totalRecord }}{{ $t("collect.个视频") }}
            </p>
            <div
              class="videoList clearfix"
              v-for="(item, i) in lists"
              :key="i"
              @click.stop.prevent="goto('video', item.id)"
            >
              <div class="imgBox">
                <img
                  class="icon8"
                  :src="item.thumb | imageUrl('', 400, 224)"
                  alt=""
                />
                <span class="time1">{{ item.duration | secondToDate }}</span>
              </div>
              <div class="infoBox">
                <p class="title1">{{ item.title }}</p>
                <p class="tagBox">
                  <span
                    class="tag"
                    v-for="(tag, i) in item.tagGroupInfoList"
                    :key="i"
                    v-if="i < 5"
                    >{{ tag }}</span
                  >
                </p>
                <div class="info">
                  <span @click.stop.prevent="goto('people', item.userId)"
                    ><img
                      class="icon9"
                      :src="
                        item.userAccountDomain.avatar | imageUrl('', 40, 40)
                      "
                      alt=""
                    /><span class="name">{{
                      item.userAccountDomain.nickName
                    }}</span></span
                  ><span class="time2">{{
                    item.createTime | formatDate("YYYY.MM.DD")
                  }}</span
                  ><span class="count"
                    ><img
                      class="icon10"
                      src="/static/video/view_icon@2x.png"
                      alt=""
                    />{{ item.viewCount }}</span
                  >
                </div>
              </div>
            </div>
            <Loading v-if="loading" />
            <Reload v-if="loadError" @callback="loadMore" />
            <no-more v-if="!hasNextPage && lists.length" />
          </div>
          <div class="noData" v-else>
            <img
              class="noVideo"
              src="/static/newSearch/video_empty@2x.png"
              alt=""
            />
            <p class="noTitle">{{ $t("collect.该看单暂无内容") }}</p>
          </div>
        </div>
        <div class="rightBox" v-if="recommendList.length">
          <div class="look">
            <p class="title3">{{ $t("collect.推荐看单") }}</p>
            <div
              class="recommendBox clearfix"
              v-for="(item, i) in recommendList"
              :key="i"
              @click.stop.prevent="gotoLook(item.id)"
            >
              <div class="recommendleftBox">
                <img
                  class="icon11"
                  :src="item.thumb | imageUrl('', 248, 140)"
                  alt=""
                />
                <div class="countBox">
                  <img
                    class="countIcon"
                    src="/static/collect/icon_playlist_corner@2x.png"
                    alt=""
                  />{{ item.videoCount }}{{ $t("collect.个视频") }}
                </div>
              </div>
              <div class="recommendrightBox">
                <p class="title">{{ item.name }}</p>
                <div
                  class="infoBox"
                  @click.stop.prevent="goto('people', item.userId)"
                >
                  <img
                    class="icon12"
                    :src="item.userAvatar | imageUrl('', 40, 40)"
                    alt=""
                  />{{ item.nickName }}
                </div>
              </div>
            </div>
          </div>
          <div class="Operation" @click="gotoLocation" v-if="locationList.length">
            <img
              :src="
                JSON.parse(locationList[0].image)[0].key
                  | imageUrl('', 570, 320)
              "
              alt=""
            />
            <div class="advertisement" v-if="locationList[0].type == '2'">
              {{ $t("video.广告") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="isSecretBox" v-if="type == 2">
      <img
        class="secretImg"
        src="/static/collect/img_playlist_locked@2x.png"
        alt=""
      />
      <p class="secretTitle">{{ $t("collect.此看单已被设置为私密") }}</p>
      <router-link to="/" class="secretBut">{{
        $t("collect.返回首页")
      }}</router-link>
    </div>
    <div class="isSecretBox" v-if="type == 1">
      <img
        class="secretImg"
        src="/static/collect/img_playlist_deleted@2x.png"
        alt=""
      />
      <p class="secretTitle">{{ textName }}</p>
      <router-link to="/" class="secretBut">{{
        $t("collect.返回首页")
      }}</router-link>
    </div>
    <el-dialog :visible.sync="reportVisible" width="22%">
      <el-form ref="form" :model="form" label-position="top">
        <el-form-item :label="`${$t('global.请填写举报理由')}：`">
          <el-checkbox-group v-model="form.reason">
            <el-checkbox
              :label="$t('global.涉及黄赌毒和暴力')"
              name="reason"
            ></el-checkbox>
            <el-checkbox :label="$t('global.政治')" name="reason"></el-checkbox>
            <el-checkbox
              :label="$t('global.版权问题')"
              name="reason"
            ></el-checkbox>
            <el-checkbox :label="$t('global.抄袭')" name="reason"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item>
          <el-input
            type="textarea"
            wrap="hard"
            v-model="form.content"
            :placeholder="$t('global.请输入举报内容，我们将尽快处理。')"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">{{
            $t("global.提交")
          }}</el-button>
        </el-form-item>
        <el-form-item>
          <p class="message">
            {{ $t("global.也可发邮件给我们") }}：info@manamana.net
          </p>
        </el-form-item>
      </el-form>
    </el-dialog>
    <service></service>
  </main-layout>
</template>

<script type="text/ecmascript-6">
import MainLayout from "@/layouts/MainLayout";
import service from "@/components/service.vue";
import Share from "@/components/v2/Share";
import Reload from "@/components/v2/match/reload";
import NoMore from "@/components/v2/NoMore";
import Loading from "@/components/v2/match/loading";
import { imageUrl } from "@/util/filters.js";
import {
  getScrollHeight,
  getScrollTop,
  getWindowHeight,
} from "@/assets/screen";
export default {
  name: "lookFolder",
  metaInfo() {
    return {
      title: this.$t("collect.看单主页") + " | MANA",
    };
  },
  data() {
    return {
      lists: [],
      details: {},
      loading: false,
      loadError: false,
      hasNextPage: true,
      videoListIndex: 1,
      videoListSize: 10,
      config: {},
      recommendList: [],
      totalRecord: 0,
      ishover: false,
      type: 3,
      reportVisible: false,
      form: {
        reason: [],
        content: "",
      },
      userId: null,
      locationList: [],
      textName: null,
      isShow: false
    };
  },
  components: {
    MainLayout,
    service,
    Share,
    Reload,
    NoMore,
    Loading,
  },
  created() {
    this.init();
  },
  mounted() {
    if (this.type == 3) {
      window.addEventListener("scroll", this.loadMore);
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.loadMore, false);
  },
  methods: {
    init() {
      if (
        this.$store.state.peopleMessage &&
        this.$store.state.peopleMessage.userId
      ) {
        this.userId = this.$store.state.peopleMessage.userId;
      } else {
        this.userId = null;
      }
      this.videoListIndex = 1;
      this.lists = [];
      this.getLookDetails();
      this.getOperation();
    },
    gotoLocation() {
      this.locationClick(this.locationList[0]);
      this.openLocatione(this.locationList[0]);
    },
    getOperation() {
      this.$http.get("/api/operations/list/18").then((res) => {
        if (res.code === "OK") {
          this.locationList = res.data;
          if (this.locationList.length) {
            this.locationShow(this.locationList[0]);
          }
        }
      });
    },
    locationClick(item) {
      let params = {
        locationId: item.locationId,
        sort: item.sort,
        configId: item.id,
      };
      this.$http.post("/api/operations/click", params).then((res) => {
        //运营位点击
      });
    },
    locationShow(item) {
      let params = {
        locationId: item.locationId,
        sort: item.sort,
        configId: item.id,
      };
      this.$http.post("/api/operations/show", params).then((res) => {
        //运营位展示
      });
    },
    getNumber(value) {
      if (!value) {
        return 0;
      }
      const newValue = ["", "", ""];
      let fr = 1000;
      let num = 3;
      let text1 = "";
      let fm = 1;
      while (value / fr >= 1) {
        fr *= 10;
        num += 1;
        // console.log('数字', value / fr, 'num:', num)
      }
      if (num <= 4) {
        // 千
        newValue[0] = value;
      } else if (num <= 8) {
        // 万
        text1 =
          parseInt(num - 4) / 3 > 1
            ? this.$t("collect.千万")
            : this.$t("collect.万");
        // tslint:disable-next-line:no-shadowed-variable
        fm = text1 === this.$t("collect.万") ? 10000 : 10000000;
        if (value % fm === 0) {
          newValue[0] = parseInt(value / fm) + "";
        } else {
          newValue[0] = parseFloat(value / fm).toFixed(1) + "";
        }
        newValue[1] = text1;
      } else if (num <= 16) {
        // 亿
        text1 =
          (num - 8) / 3 > 1 ? this.$t("collect.千亿") : this.$t("collect.亿");
        text1 = (num - 8) / 4 > 1 ? this.$t("collect.万亿") : text1;
        text1 = (num - 8) / 7 > 1 ? this.$t("collect.千万亿") : text1;
        // tslint:disable-next-line:no-shadowed-variable
        fm = 1;
        if (text1 === this.$t("collect.亿")) {
          fm = 100000000;
        } else if (text1 === this.$t("collect.千亿")) {
          fm = 100000000000;
        } else if (text1 === this.$t("collect.万亿")) {
          fm = 1000000000000;
        } else if (text1 === this.$t("collect.千万亿")) {
          fm = 1000000000000000;
        }
        if (value % fm === 0) {
          newValue[0] = parseInt(value / fm) + "";
        } else {
          newValue[0] = parseFloat(value / fm).toFixed(1) + "";
        }
        newValue[1] = text1;
      }
      if (value < 1000) {
        newValue[0] = value + "";
        newValue[1] = "";
      }
      return newValue.join("");
    },
    onSubmit() {
      this.$http
        .post(
          "/api/u/report/?reason=" +
            this.form.reason.toString() +
            "&content=" +
            this.form.content +
            "&domainId=" +
            this.details.id +
            "&type=7"
        )
        .then(function (response) {
          if (response.code === "OK") {
            this.$message.success($this.$t("global.提交成功"));
            this.reportVisible = false;
          }
        });
    },
    gotoVideo(id) {
      if (this.details.videoCount > 0) {
        let routeData = this.$router.resolve({
          path: "/video/detail?id=" + this.lists[0].id + "&lookId=" + id,
        });
        window.open(routeData.href, "_blank");
      }
    },
    collectLook(index) {
      if (index == 1) {
        if (this.userId == this.details.userId) {
          return;
        }
        this.$http
          .post("/api/u/fav/collectFav/" + this.$route.params.id)
          .then((res) => {
            if (res.code === "OK") {
              this.$message.success(res.message);
              this.getLookDetails();
            }
          });
      }
      if (index == 2) {
        this.$http
          .delete("/api/u/fav/collect/" + this.$route.params.id)
          .then((res) => {
            if (res.code === "OK") {
              this.$message.success(this.$t("collect.取消收藏成功！"));
              this.getLookDetails();
            }
          });
      }
    },
    gotoLook(id) {
      this.$router.push("/playlist/" + id);
    },
    goto(type, id) {
      let routeData = null,
        url = "";
      if (type == "video") {
        url = "/video/detail?id=" + id;
      }
      if (type == "people") {
        url = "/peopleCenter/" + id + "/home";
      }
      routeData = this.$router.resolve({ path: url });
      window.open(routeData.href, "_blank");
    },
    loadMore() {
      if (this.details.videoCount > 0) {
        if (getScrollTop() + getWindowHeight() >= getScrollHeight() - 500) {
          if (!this.loading && this.hasNextPage && this.type == 3) {
            this.videoListIndex++;
            this.getVideoList();
          }
        }
      }
    },
    getLookDetails() {
      this.$http
        .get("/api/fav/recommendFav/" + this.$route.params.id)
        .then((res) => {
          if (res.code === "OK") {
            //1.删除  2.私密
            if (res.data == 1) {
              this.type = 1;
              this.textName = this.$t("collect.此看单已被删除");
            } else if (res.data == 2) {
              this.type = 2;
            } else {
              this.type == 3;
              this.details = res.data;
              this.isShow = true;
              if (this.details.videoCount > 0) {
                this.getVideoList();
              }
              this.getRecommendFav();
            }
            this.config = {
              share_url: location.href,
              title: "MANA | " + this.details.name,
              desc: "MANA " + this.$t("global.全球新媒体艺术平台"),
              pics: imageUrl(this.details.thumb),
            };
          } else {
            this.type = 1;
            this.textName = this.$t("collect.此看单不存在");
          }
        });
    },
    getVideoList() {
      this.loading = true;
      let params = {
        id: this.$route.params.id,
        pageIndex: this.videoListIndex,
        pageSize: this.videoListSize,
      };
      this.$http
        .get("/api/fav/collectVideoList/" + this.$route.params.id, { params })
        .then((res) => {
          this.loading = false;
          if (res.code === "OK") {
            if (this.videoListIndex === 1) {
              this.lists = [];
            }
            this.loadError = false;
            this.lists = [...this.lists, ...res.data.list];
            this.hasNextPage = res.data.hasNextPage;
            this.totalRecord = res.data.totalRecord;
          } else {
            if (this.videoListIndex !== 1) {
              this.videoListIndex--;
            }
            this.loadError = true;
          }
        });
    },
    getRecommendFav() {
      this.$http.get("/api/fav/recommendFav").then((res) => {
        if (res.code === "OK") {
          if (res.data.length) {
            this.recommendList = res.data.filter((item) => {
              return item.id != this.$route.params.id;
            });
          }
        }
      });
    },
  },
  watch: {
    $route(to) {
      this.init();
    },
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.lookBox {
  background: #fff;

  .lookFolder {
    width: 1110px;
    margin: 0 auto;
    padding: 40px 0 120px 0;

    .leftBox {
      float: left;
      width: 760px;
      margin-right: 65px;

      .leftTopBox {
        margin-bottom: 50px;

        .lookTitle {
          height: 24px;
          font-size: 16px;
          font-weight: 400;
          color: #999999;
          line-height: 24px;

          .icon1 {
            width: 24px;
            height: 24px;
            margin-right: 6px;
          }
        }

        .title {
          max-height: 68px;
          font-size: 24px;
          font-weight: 600;
          color: #0A0A0A;
          line-height: 34px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          word-break: break-word;
          margin: 16px 0;
        }

        .lookInfo {
          position: relative;
          font-size: 13px;
          font-weight: 400;
          color: #666666;

          .name {
            color: #999999;
            cursor: pointer;

            .icon2 {
              width: 26px;
              height: 26px;
              margin: 0 8px 0 4px;
              border-radius: 50%;
              vertical-align: middle;
            }
          }

          .time {
            margin: 0 30px;
          }

          .count {
            font-size: 13px;
            font-weight: 400;
            color: #B8B8B8;

            .icon3 {
              width: 18px;
              height: 12px;
              margin-right: 4px;
              vertical-align: middle;
            }
          }

          .reportBox {
            position: absolute;
            right: 0;
            font-size: 13px;
            font-weight: 400;
            color: #B8B8B8;
            cursor: pointer;

            .icon4 {
              width: 20px;
              height: 20px;
              margin-right: 2px;
              vertical-align: middle;
            }
          }
        }

        .bottomBox {
          margin-top: 28px;

          .playAll {
            float: left;
            width: 112px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            background: #2026CC;
            font-size: 14px;
            font-weight: 600;
            color: #FFFFFF;
            cursor: pointer;

            .icon5 {
              width: 20px;
              height: 20px;
              margin-right: 2px;
              vertical-align: middle;
            }
          }

          .playAllNo {
            background: #B8B8B8;
          }

          .collectClose {
            float: left;
            width: 112px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            border: 1px solid #999999;
            font-size: 14px;
            font-weight: 600;
            color: #999999;
            box-sizing: border-box;
            margin: 0 10px;
            cursor: pointer;

            i {
              font-size: 12px;
              font-weight: 400;
              margin-left: 5px;
            }
          }

          .collectAdd {
            float: left;
            padding: 0 16px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            border: 1px solid #2026CC;
            font-size: 14px;
            font-weight: 600;
            color: #2026CC;
            box-sizing: border-box;
            margin: 0 10px;
            cursor: pointer;

            .icon6 {
              width: 20px;
              height: 20px;
              margin-right: 5px;
              margin-bottom: 2px;
              vertical-align: middle;
            }

            i {
              font-size: 12px;
              font-weight: 400;
              margin-left: 5px;
            }
          }

          .notClick {
            cursor: no-drop;
            border: 1px solid #999999;
            color: #999999;
          }

          .config {
            float: left;
            width: 90px;
            height: 32px;
            line-height: 32px;
            border: 1px solid #2026CC;
            text-align: center;
            font-size: 14px;
            font-weight: 600;
            color: #2026CC;
            box-sizing: border-box;

            .icon7 {
              width: 20px;
              height: 20px;
              margin-right: 4px;
              margin-bottom: 2px;
              vertical-align: middle;
            }
          }
        }
      }

      .leftVideoListBox {
        width: 760px;
        padding: 24px 20px 70px;
        box-sizing: border-box;
        background: #FAFAFA;

        .title {
          height: 23px;
          font-size: 15px;
          font-weight: 400;
          color: #999999;
          line-height: 23px;
          margin-bottom: 24px;
        }

        .videoList {
          height: 112px;
          margin-bottom: 30px;
          cursor: pointer;

          .imgBox {
            float: left;
            width: 200px;
            height: 112px;
            position: relative;
            margin-right: 15px;

            .icon8 {
              width: 200px;
              height: 112px;
            }

            .time1 {
              position: absolute;
              padding: 0 6px;
              height: 20px;
              line-height: 20px;
              background: rgba(10, 10, 10, 0.8);
              bottom: 5px;
              right: 5px;
              font-size: 12px;
              font-weight: 600;
              color: #FFFFFF;
            }
          }

          .infoBox {
            float: left;
            width: 505px;
            height: 112px;
            position: relative;

            .title1 {
              max-height: 45px;
              font-size: 16px;
              font-weight: 600;
              color: #0A0A0A;
              line-height: 22px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              word-break: break-word;
            }

            .tagBox {
              margin-top: 8px;

              .tag {
                display: inline-block;
                padding: 0 6px;
                height: 22px;
                line-height: 22px;
                text-align: center;
                background: #EBEBEB;
                vertical-align: middle;
                font-size: 12px;
                font-weight: 400;
                color: #666666;
                margin-right: 8px;
                overflow: hidden;
                text-overflow: ellipsis;
                vertical-align: middle;
              }
            }

            .info {
              position: absolute;
              bottom: 0;
              left: 0;
              height: 20px;
              line-height: 20px;

              .icon9 {
                width: 20px;
                height: 20px;
                border-radius: 50%;
                margin-right: 6px;
                vertical-align: bottom;
              }

              .name {
                font-size: 12px;
                font-weight: 400;
                color: #333333;
              }

              .time2 {
                font-size: 12px;
                font-weight: 400;
                color: #999999;
                margin: 0 20px 0 18px;
              }

              .count {
                font-size: 12px;
                font-weight: 400;
                color: #B8B8B8;

                .icon10 {
                  width: 18px;
                  height: 12px;
                  margin-right: 2px;
                  vertical-align: middle;
                  margin-bottom: 3px;
                }
              }

              &:hover {
                .name {
                  color: #0A0A0A;
                }
              }
            }
          }
        }
      }

      .noData {
        padding: 100px 0;
        text-align: center;

        .noVideo {
          width: 88px;
          height: 88px;
          margin-bottom: 10px;
        }

        .noTitle {
          height: 21px;
          font-size: 15px;
          font-weight: 400;
          color: #B8B8B8;
          line-height: 21px;
        }
      }
    }

    .rightBox {
      width: 285px;
      float: left;
      padding-top: 32px;

      .look {
        .title3 {
          height: 30px;
          font-size: 20px;
          font-weight: 600;
          color: #0A0A0A;
          line-height: 30px;
          margin-bottom: 20px;
        }

        .recommendBox {
          height: 70px;
          width: 285px;
          margin-bottom: 20px;
          cursor: pointer;

          .recommendleftBox {
            float: left;
            width: 124px;
            height: 70px;
            position: relative;
            margin-right: 11px;

            .icon11 {
              width: 124px;
              height: 70px;
            }

            .countBox {
              position: absolute;
              padding: 0 5px;
              height: 28px;
              line-height: 28px;
              text-align: center;
              background: rgba(0, 0, 0, 0.59);
              border-radius: 0px 4px 0px 0px;
              left: 0;
              bottom: 0;
              font-size: 12px;
              font-weight: 400;
              color: #FFFFFF;

              .countIcon {
                width: 20px;
                height: 20px;
                vertical-align: middle;
                margin-right: 4px;
                margin-bottom: 4px;
              }
            }
          }

          .recommendrightBox {
            width: 150px;
            float: left;

            .title {
              height: 44px;
              font-size: 15px;
              font-weight: 600;
              color: #333333;
              line-height: 22px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              word-break: break-word;
              margin-bottom: 6px;
            }

            .infoBox {
              font-size: 12px;
              font-weight: 400;
              color: #666666;

              .icon12 {
                width: 20px;
                height: 20px;
                border-radius: 50%;
                margin-right: 6px;
              }
            }
          }
        }
      }

      .Operation {
        width: 285px;
        height: 160px;
        margin-top: 70px;
        cursor: pointer;
        position: relative;

        img {
          width: 100%;
          height: 100%;
        }

        .advertisement {
          position: absolute;
          left: 0;
          bottom: 0;
          padding: 0 4px;
          height: 16px;
          background: rgba(51, 51, 51, 0.4);
          border-radius: 0px 6px 0px 0px;
          line-height: 16px;
          text-align: center;
          font-size: 10px;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.8);
        }
      }
    }
  }
}

.isSecretBox {
  width: 100%;
  text-align: center;
  padding: 120px 0 250px 0;

  .secretImg {
    width: 88px;
    height: 88px;
  }

  .secretTitle {
    height: 21px;
    font-size: 15px;
    font-weight: 400;
    color: #666666;
    line-height: 21px;
    margin: 8px 0 40px;
  }

  .secretBut {
    display: block;
    margin: 0 auto;
    width: 144px;
    height: 40px;
    background: #2026CC;
    line-height: 40px;
    font-size: 16px;
    font-weight: 600;
    color: #FFFFFF;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/lookFolder/lookFolder.vue